import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { truthy } from '@nestech/utils';
import { MemberStore } from '@web/service';
import { map } from 'rxjs';
import { areaNotHidden } from './area-not-hidden.guard';
import { liveI18NModeGuardFn } from './live-i18n-mode.guard';
import { memberLoaded } from './member-loaded.guard';
import { memberBlocked, memberNotBlocked } from './member-not-blocked.guard';

const memberGuardFn: CanMatchFn = () => {
  return inject(MemberStore).member$.pipe(
    truthy(),
    map(c => !!c),
  );
};

export const BaseGuards = {
  areaNotHidden,
  memberLoaded,
  liveI18NModeGuardFn,
  memberGuardFn,
  memberNotBlocked,
  memberBlocked,
};
